// extracted by mini-css-extract-plugin
module.exports = {"modal":"ListHotelPopUp_modal__XLKJ8"};